import React from 'react';
import MultiCourseHealth from './MultiCourseHealth';
import { HealthContainer } from './styles';

const Health: React.FC = () => {
  return (
    <HealthContainer>
      <MultiCourseHealth />
    </HealthContainer>
  );
};

export default Health;
